export const expiryDatetime = '2023-11-27 00:00:00';
export const auth = true;
export const minimum = 100;
export const maxToken = 999999;
export const currentToken = 500000;
export const gaugeMeter = (currentToken / maxToken) * 100;
export const unitPrice = '0.00';
